// The public cover catalog, on the page (owner, 2026-10-17) — mirrors worker
// lib/coverCatalog.ts and lib/waPool.ts. Pure. Guard: coverCatalogClient.test.ts
import type { CatalogCover, Cover } from './api';

/** The text « Je choisis ce modèle » pre-fills — the worker reads it back (parseCoverChoice). */
export function chooseMessage(name: string, slug: string): string {
  return `Bonjour, je veux la couverture ${String(name).trim()} (${slug})`;
}

/** The storefront's weighted draw (the theme's own rule). */
export function pickNumber(pool: Array<{ n: string; w: number }>, rand: number): string | null {
  const total = pool.reduce((t, x) => t + (Number(x.w) || 0), 0);
  if (!pool.length || total <= 0) return null;
  let r = rand * total;
  for (const x of pool) { r -= Number(x.w) || 0; if (r < 0) return x.n; }
  return pool[pool.length - 1].n;
}

export function waLink(number: string, text: string): string {
  return `https://wa.me/${String(number).replace(/\D/g, '')}?text=${encodeURIComponent(text)}`;
}

/** A catalog cover in the shape the shared CoverThumbnail draws (colour + artwork + its title/year). */
export function asThumbnailCover(c: CatalogCover, hd = false): Cover {
  return {
    id: c.id,
    name: c.name,
    categories: c.categories,
    thumbnail_url: (hd ? c.thumbnail_url_hd : c.thumbnail_url) ?? c.thumbnail_url,
    design_url: (hd ? c.design_url_hd : c.design_url) ?? c.design_url,
    dominant_color: c.dominant_color,
    text_zones: c.text_zones,
    width_px: c.width_px,
    height_px: c.height_px,
    is_visible: true,
  } as unknown as Cover;
}

/** ?cat= from the address, only a known category. */
export function catFromSearch(search: string, known: string[]): string | null {
  const v = new URLSearchParams(search).get('cat');
  return v && known.includes(v) ? v : null;
}
